<template>
  <div class="form-wrapper">
    <div class="container form-page">
      <form-header />

      <form class="row"
        @submit.prevent="checkStatus"
        method="POST"
        enctype="multipart/form-data">
          <div class="col-12 bg-white rounded mt-4 pb-4 pt-4 border">
            <div class="article-header">
              <h1>{{$t('Checking the status of an application')}}</h1>
              <hr>
            </div>
            <div class="article-description">
              <i>{{$t('Here you can check the status of the application')}}</i>
            </div>

            <template v-if="formResponse">
              <div v-if="formResponse.success === true && formResponse.status === 0" class="alert alert-info" role="alert">
                <i class="el-icon-remove"></i> {{$t('Your application is pending')}}
              </div>
              <div v-if="formResponse.success === true && formResponse.status === 1" class="alert alert-success" role="alert">
                <i class="el-icon-success"></i> {{$t('Your application has been approved')}}
              </div>
              <div v-if="formResponse.success === false || formResponse.status === 2" class="alert alert-danger" role="alert">
                <i class="el-icon-error"></i>
                {{formResponse.success === true ? $t('You have been denied a place in a dormitory') : ''}}
                <br>
                {{
                  formResponse.messages.join(". ")
                }}
              </div>
            </template>

              <div class="form-row row-centered mt-2">
                <div class="form-group col-md-12 col-12">
                  <application-form-error
                    v-if="errors.email"
                    :error="errors.email"
                  />
                  <label for="email">
                    {{ $t('form.email') }}
                    <i style="color: rgb(255, 0, 0)">*</i></label
                  >
                  <input
                    type="email"
                    id="email"
                    placeholder="email"
                    :class="['form-control', {'is-invalid': errors.email}]"
                    :masked="true"
                    v-model="form.email"
                  />
                </div>
              </div>

              <div class="form-row row-centered mt-2">
                <div class="form-group col-md-12 col-12">
                  <application-form-error
                    v-if="errors.phone"
                    :error="errors.phone"
                  />
                  <label for="phone">
                    {{ $t('form.phone') }}
                    <i style="color: red">*</i>
                  </label>
                  <masked-input
                    @input="form.phone = '8' + arguments[1]"
                    type="tel"
                    id="phone"
                    mask="8 (111) 11-11-111"
                    placeholder="8 (___) __-__-___"
                    :class="['form-control', {'is-invalid': errors.phone}]"
                  />
                </div>
              </div>

              <button
                class="btn btn-success mt-3 justify-content-center mx-auto"
                type="submit"
              >
                {{ $t('form.submit_btn') }}
              </button>
              </div>
            </form>
    </div>

    <div class="container fixed-bottom">
      <div class="row">
        <router-link to="/" class="btn btn-success mt-3 justify-content-center mx-auto article-back-btn">
            {{ $t('article.back_btn') }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/article.css'
import formApi from '@/api/form'
import FormHeader from '@/components/form/FormHeader'
import ApplicationFormError from '@/components/ApplicationFormError'
import MaskedInput from 'vue-masked-input'

export default {
  components: {FormHeader, ApplicationFormError, MaskedInput},
  data(){
    return {
      formResponse: null,
      form: {
        email: '',
        phone: '',
      },
      errors: {
        email: '',
        phone: ''
      }
    }
  },
  methods: {
    checkStatus() {
      if (!this.validate(this.form)) {
        this.isSubmitted = true

        for (let key in this.errors) {
          if (
            this.errors[key] &&
            !['country', 'region', 'city', 'street', 'house', 'flat'].includes(
              this.errors[key]
            )
          ) {
            document.querySelector(`#${key}`).scrollIntoView()
            break
          }
        }

        return
      }

      formApi
        .statusCheck({email: this.form.email, phone: this.form.phone, lang: this.$i18n.locale})
        .then(response => this.formResponse = response.data)
    },
    validate(data) {
      if (!data.email) this.errors.email = this.$t('form.errors.email')
      else this.errors.email = ''

      if (data.phone.length !== 11 || data.phone.includes('_'))
        this.errors.phone = this.$t('form.errors.phone')
      else this.errors.phone = false

      for (const [, value] of Object.entries(this.errors))
        if (value) return false

      return true
    }
  }
}
</script>